import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import api from '../api';

// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
import USERLIST from '../_mock/user';
import UpdateResultModal from '../sections/@dashboard/resultDeclare/UpdateResultModal';
import AutoDeclarePanel from '../sections/@dashboard/resultDeclare/AutoDeclarePanel';
import moment from 'moment';
import { updateGameAction } from 'src/redux/actions/masterGameAction';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import { row_per_page_data } from 'src/utils/commonUtils';

const TABLE_HEAD = [
  { id: 'game_name', label: 'Game Name', alignRight: false },
  { id: 'createdAt', label: 'Result Date', alignRight: false },
  { id: 'open_declared_date', label: 'Open Declare Date', alignRight: false },
  { id: 'close_declared_date', label: 'Close Declare Date', alignRight: false },
  { id: 'open_pana', label: 'Open Pana', alignRight: false },
  { id: 'close_pana', label: 'Close Pana', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ResultDeclareResult() {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('desc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('createdAt');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(row_per_page_data[0]);

  const [masterGameData, setMasterGameData] = useState([]);

  const [selectedGame, setSelectedGame] = useState('');
  const [date, setDate] = useState();

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = masterGameData.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const getAllDeclaredResults = async () => {
    dispatch(loadingStartAction());
    const response = await api.get('/declare-results');
    setMasterGameData(response.data.results);
    dispatch(loadingStopAction());
  };

  const deleteDeclareResult = async (_selectedGame) => {
    handleCloseMenu();
    if (confirm('Are you sure you want to delete?')) {
      dispatch(loadingStartAction());
      await api.delete(`/declare-results/${_selectedGame._id}`);
      getAllDeclaredResults();
    }
  };

  const getAllDeclaredResultsByDateAndTime = async (newVal) => {
    // handleCloseMenu();
    dispatch(loadingStartAction());
    let reqBody = {
      date: newVal,
    };
    let response = await api.post(`/declare-results/query`, reqBody);
    setMasterGameData(response.data.results);
    dispatch(loadingStopAction());
  };

  const getAllPendingDeclaredResults = async () => {
    dispatch(loadingStartAction());
    const response = await api.get('/declare-results');
    setMasterGameData(response.data.results);
    dispatch(loadingStopAction());
  };

  const refundHandler = async (selectedGame) => {
    if (confirm('Are you sure you want to refund?')) {
      dispatch(loadingStartAction());

      const reqBody = {
        game_id: selectedGame.game_id,
        master_game_created_date: selectedGame.master_game_created_date,
      };
      await api.post('/declare-results/refund-points', reqBody);
      dispatch(loadingStopAction());
    }
  };

  useEffect(() => {
    // getAllDeclaredResults();
    // getAllPendingDeclaredResults()

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    console.log(currentDate.toISOString());

    getAllDeclaredResultsByDateAndTime(currentDate);
  }, []);

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - masterGameData?.length) : 0;

  const filteredFinalData = applySortFilter(masterGameData, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredFinalData.length && !!filterName;
  if (!masterGameData) return <h1>Loading</h1>;
  return (
    <>
      <Helmet>
        <title> User | Minimal UI </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <UpdateResultModal />

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DatePicker']}>
              <DatePicker
                label="Select Date"
                value={date}
                onChange={(newValue) => {
                  setDate(newValue);
                  getAllDeclaredResultsByDateAndTime(newValue);
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </Stack>

        <AutoDeclarePanel onDeclared={() => getAllDeclaredResultsByDateAndTime(date)} />

        <Card>
          {/* <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={masterGameData.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredFinalData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const {
                      _id,
                      open_declared_date,
                      close_declared_date,
                      updatedAt,
                      open_panna,
                      open_digit,
                      close_digit,
                      close_panna,
                      game,
                    } = row;
                    const selectedUser = selected.indexOf(game?.game_name) !== -1;

                    return (
                      <TableRow hover key={_id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell padding="checkbox">
                          {/* <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, game?.game_name)} /> */}
                        </TableCell>

                        <TableCell component="th" scope="row" padding="none">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            {/* <Avatar alt={game?.game_name} src={pic} /> */}
                            <Typography variant="subtitle2" noWrap>
                              {game?.game_name}
                            </Typography>
                          </Stack>
                        </TableCell>

                        <TableCell align="left">{moment(updatedAt).format('MMMM Do YYYY')}</TableCell>

                        {/* MMMM Do YYYY, */}
                        <TableCell align="left">
                          {moment(open_declared_date).format('MMMM Do YYYY, hh:mm:ss')}
                        </TableCell>
                        <TableCell align="left">
                          {moment(close_declared_date).format('MMMM Do YYYY, hh:mm:ss')}
                        </TableCell>

                        <TableCell align="left">
                          <Label>
                            {open_panna}-{open_digit}
                          </Label>
                        </TableCell>

                        <TableCell align="left">
                          <Label>
                            {close_digit}-{close_panna}
                          </Label>
                        </TableCell>

                        <TableCell align="right">
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}
                          >
                            <Label
                              style={{ marginRight: 10, cursor: 'pointer' }}
                              onClick={() => deleteDeclareResult(row)}
                              color="error"
                            >
                              Delete
                            </Label>
                            <Label
                              onClick={() => refundHandler(row)}
                              style={{ cursor: 'pointer' }}
                              color={row?.is_refunded ? 'success' : 'info'}
                            >
                              {row?.is_refunded ? 'REFUNDED' : 'REFUND NOW'}
                            </Label>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}

                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={row_per_page_data}
            component="div"
            count={filteredFinalData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      {/* <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => deleteDeclareResult()} sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover> */}
    </>
  );
}
